<template>
  <header :class="{ 'bd-banner-navbar': isBannerEnabled }" class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar">
    <router-link class="navbar-brand mr-0 mr-md-2 custom-brand" to="/" aria-label="adas">
      <img v-if="logo !== null" :src="logo" alt="adas" style="height: 48px" />
      <img v-else src="~@/assets/images/Opus_IVS_90h_extrawhite.png" alt="adas" style="height: 48px; background: #fff" />
      <span class="custom-app-title" v-html="title"></span>
    </router-link>

    <div class="navbar-nav-scroll">
      <ul class="navbar-nav bd-navbar-nav flex-row">
        <li class="nav-item" v-for="n of nav" :key="n.name">
          <router-link exact class="nav-link" v-if="isAllowed(n.url)" :to="n.url" title="n.name">{{ n.name }}</router-link>
        </li>
      </ul>
    </div>

    <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
      <li v-if="profile.username" class="nav-item">
        <a id="profile" href="#" @click="showProfile" class="nav-link" title="profile">
          <i class="fas fa-user pr-1"></i>
          {{ username }}
        </a>
        <div class="custom-firm">
          {{ firmName }}
        </div>
      </li>
      <li class="nav-item">
        <a id="logout" href="#" @click="logout" class="nav-link" title="logout">
          <i class="fas fa-sign-out-alt"></i>
          Logout
        </a>
      </li>
    </ul>
    <!-- Service Hub -->
    <service-hub />
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ServiceHub from '@/components/admin/service-hub'
export default {
  name: 'nav-top',
  components: {
    ServiceHub
  },
  data() {
    return {
      nav: [{ url: '/adas', name: 'ADAS' }]
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('auth', ['profile', 'isAllowed']),
    ...mapGetters('locations', ['preferences']),
    ...mapGetters('lookups', ['brand']),
    logo() {
      let _logo = null
      if (this.brand) {
        if (this.brand.length > 0) {
          let item = this.brand.filter((x) => x.name === 'BrandLogo')
          if (item.length > 0) {
            _logo = item[0].value
          }
        }
      }
      return _logo
    },
    favIcon() {
      let _icon = null
      if (this.brand) {
        if (this.brand.length > 0) {
          let item = this.brand.filter((x) => x.name === 'BrandIcon')
          if (item.length > 0) {
            _icon = item[0].value
          }
        }
      }
      return _icon
    },
    title() {
      let _title = 'ADAS Map&trade;'
      if (this.brand) {
        if (this.brand.length > 0) {
          let item = this.brand.filter((x) => x.name === 'BrandTitle')
          if (item.length > 0) {
            _title = item[0].value
          }
        }
      }
      return _title
    },
    isShop() {
      let _is = false
      if (this.profile) {
        if ([15, 16, 17].includes(this.profile.roles[0])) {
          _is = true
        }
      }
      return _is
    },
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    mainLogo() {
      let _data = ''
      if (this.preferences.length > 0) {
        let item = this.preferences.filter((x) => x.name === 'MainLogo')
        if (item.length > 0) {
          _data = item[0].value
        }
      }
      return _data
    },
    username: {
      get() {
        let user = ''
        if (this.profile !== undefined && this.profile !== null) {
          user = this.profile.username
        }
        return user
      }
    },
    firm() {
      let _firm = null
      if (this.profile) {
        _firm = this.profile.firm
      }
      return _firm
    },
    firmName() {
      let _name = null
      if (this.profile) {
        _name = this.profile.firmName
      }
      return _name
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    ...mapActions('locations', ['getPreferences']),
    ...mapActions('lookups', ['getBrand']),
    async init() {
      this.nav = []
      await this.getBrand({
        firm: this.profile.firm
      })
    },
    updateFavIcon() {
      console.log('Updating favicon')
      let oldFavicon = document.getElementById('favicon')
      var link = document.createElement('link')
      link.id = 'favicon'
      link.type = 'image/x-icon'
      link.rel = 'icon'
      link.href = this.favIcon + '?=' + Math.random()
      if (oldFavicon) {
        document.head.removeChild(oldFavicon)
      }
      document.head.appendChild(link)
    },
    showProfile() {
      this.$emit('showProfile')
    },
    logout() {
      this.clearToken()
      window.location.assign('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-brand {
  position: relative;
  padding: 5px;
}
.custom-app-title {
  color: #fff;
  font-size: 0.7em;
  font-weight: 500;
}
.custom-firm {
  color: white;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: 8px;
  width: 260px;
  font-size: 0.8em;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/nav-top.vue